import React from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import Loader from 'components/Loaders'
import { CYCLR_CALENDAR } from 'config'

import UpcomingMeetingCard from './UpcomingMeetingCard'
import { DateWrapper, EventsWrapper, UpcomingEventsWrapper } from 'components/Calendar/style'

const UpcomingMeeting = ({
  user,
  timeMin,
  timeMax,
  upcomingEventLoading,
  upComingEvents,
  cancelMeetingLoading,
  cancelUserCalendarEventAction,
  updateUserCalendarEventAction,
  cancelOutLookMeetingAction,
  deleteGoogleCalendarEventAction,
}) => {
  return (
    <UpcomingEventsWrapper>
      <EventsWrapper>Upcoming Events</EventsWrapper>
      {upcomingEventLoading ? (
        <Loader loader={'Meeting'} />
      ) : !upcomingEventLoading && isEmpty(upComingEvents) ? (
        <p className="font-primary font-bold text-lg my-4 sm:my-8">No Upcoming Events</p>
      ) : (
        Object.keys(upComingEvents).map((key, index) => {
          return (
            <div className="eventDateWrapper xs:mt-[21px] sm:mt-[27px]" key={index}>
              <DateWrapper>{moment(key).format('MMMM DD, YYYY')}</DateWrapper>

              {upComingEvents[key].map((event, ind) => {
                return (
                  <UpcomingMeetingCard
                    user={user}
                    cancelMeetingLoading={cancelMeetingLoading}
                    key={`${index}-${event.start}-${ind}`}
                    cancelUserCalendarEventAction={cancelUserCalendarEventAction}
                    calendarName={CYCLR_CALENDAR.GOOGLE_CALENDAR}
                    event={event}
                    timeMin={timeMin}
                    timeMax={timeMax}
                    isExpandable={true}
                    updateMeetingAction={updateUserCalendarEventAction}
                    cancelOutLookMeetingAction={cancelOutLookMeetingAction}
                    deleteGoogleCalendarEventAction={deleteGoogleCalendarEventAction}
                  />
                )
              })}
            </div>
          )
        })
      )}
    </UpcomingEventsWrapper>
  )
}

export default UpcomingMeeting
